var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hik-multi-wrap"},[(_vm.tipText)?_c('div',{staticClass:"hik-tip"},[_vm._v(_vm._s(_vm.tipText))]):_vm._e(),_c('div',{staticClass:"hik-plugin-host",attrs:{"id":_vm.containerId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }